import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { Badge } from './Badge.js';
const currentWeekDayIdx = new Date().getDay();
//TODO: Add logic time https://github.com/redneckz/wildless-cms-uni-blocks/pull/1549
export const renderCurrentDaySchedule = (workScheduleWeek) => {
    const [currentWeekDay] = workScheduleWeek?.slice(currentWeekDayIdx - 1) ?? [];
    if (!currentWeekDay) {
        return null;
    }
    const { lunchHour, status, workTime, hasLunch } = currentWeekDay;
    return status ? (_jsxs("div", { className: "flex gap-s items-start whitespace-nowrap", children: [workTime ? _jsx(Badge, { color: "green", children: workTime }) : null, lunchHour && hasLunch ? _jsx(Badge, { color: "yellow", children: `перерыв: ${lunchHour}` }) : null] })) : (_jsx(Badge, { color: "red", children: "\u0412\u044B\u0445\u043E\u0434\u043D\u043E\u0439" }));
};
//# sourceMappingURL=renderCurrentDaySchedule.js.map